import { styled } from '@mui/material/styles';

import IconButton from '@mui/material/IconButton';

const OrderCardExpandButton = styled((props) => {
  const { expand, onClick, icon, ...other } = props;

  return (
    <IconButton
      {...other}
      onClick={onClick}
      color="primary"
      aria-expanded={expand}
      aria-label="show more"
    >
      {icon}
    </IconButton>
  );
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

export { OrderCardExpandButton };
